import {mergeStyleSets} from "@fluentui/react";

export const useStyles = () => {
  return mergeStyleSets({
    title: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 300,
      fontSize: '20px',
      borderBottom: '1px solid #A5A5A5',
      padding: '8px',
    }
  })
}